<template>
    <div class="pl-1 list-es" v-if="districts_data != null">
        <span 
            v-for="district in districts_data"
            :key="district.id"
        >
            <span
                @click="chooseDistrict(district.id)"
                :class="'badge badge-' + $root.network"
            >
                {{ district['title'] }}
                <span v-if="district.count" class="badge badge-light text-success">{{ district.count }}</span>
                <span v-if="district.quarters && district.quarters.length > 0">
                    <masked-image class="badge-arrow" src="/img/icons/arrow-list.svg" ></masked-image>
                </span>
            </span>
            <ul v-if="district.quarters && district.quarters.length > 0 && district_open == district.id">
                
                <li
                    v-for="quarter in district.quarters"
                    :key="quarter.id"
                >
                    <div class="form-check">
                    <input
                        type="checkbox"
                        :checked="quarter.checked ? 'checked' : ''"
                        :value="district.id + '|' + quarter.id"
                        :id="'input_' + district.id + '_' + quarter.id"
                        @change="selectQuarter"
                        class="form-check-input"
                    >
                    <label
                        :class="quarter.checked ? 'font-weight-bold' : '' "  
                        :for="'input_' + district.id + '_' + quarter.id"
                    >{{ quarter.title }}</label>
                    </div>
                </li>
               
            </ul>
        </span>
    </div>
</template>
<script>
export default {
    props: {
        districts_list: {
            type: Array,
            required: false,
        },

        city: {
            type: [String, Number],
            required: false,
        },

        districts: {
            type: [String, Number],
            required: false,
        },

        quarters: {
            type: [String, Number],
            required: false,
        },
    },

    data() {
        return {
            // ssr: true,
            districts_data: [],
            districts_list_data: this.districts_list,
            district_open: null,
            quarters_data: []
        }
    },

    mounted() {
        if (this.quarters) {
            this.quarters_data = this.quarters.toString().split('|').map(el => {
                let n = Number(el)
                return n === 0 ? n : n || el
            })
        }

        if (this.districts) {
            let districts_id = this.districts.toString().split('|').map(el => {
                let n = Number(el)
                return n === 0 ? n : n || el
            })
            
            if (districts_id.length > 1) {
                this.district_assign(this.districts_list, districts_id)
            }
        }

        window.events.$on('list.districts', event => {
            this.district_open = null
            // this.ssr = false
            this.districts_data = []

            if (event) {
                let districts_id = []
                event.forEach(district => {
                    districts_id.push(district.id)
                })

                if (districts_id.length > 1) {
                    this.district_assign(this.districts_list_data, districts_id)
                }
            }
        })

        window.events.$on('list.districts.all', event => {
            this.districts_list_data = event
        })

        window.events.$on('list.quarters', event => {
            this.district_open = null
            this.quarters_data = []

            if (event) {
                event.forEach(quarter => {
                    this.quarters_data.push(quarter.id)
                })
            }
        })
    },

    methods: {
        chooseDistrict(district) {
            this.district_open = this.district_open != district ? district : null
        },

        district_assign(districts, districts_id) {
            districts.forEach(district => {
                district.id = district.id ?? district.district_id
                district.count = 0
                if (districts_id.includes(district.id)) {
                    district.title = district.title ?? district.district_title
                    if (district.quarters) {
                        let quarter_count = 0
                        district.quarters.forEach((quarter, quarter_index) => {
                            if (this.quarters_data.includes(quarter.id)) {
                                district.quarters[quarter_index].checked = 1
                                district.count++
                                quarter_count = 1
                            } else {
                                district.quarters[quarter_index].checked = 0
                            }
                        })
                        if (!quarter_count) {
                            district.quarters.forEach((quarter, quarter_index) => {
                                district.quarters[quarter_index].checked = 1
                            })
                        }
                    }
                    this.districts_data.push(district)
                }
            })
        },

        selectQuarter(event) {
            let district = event.target.value.split('|')[0]
            let quarter = event.target.value.split('|')[1]
            let quarters = this.quarters ? this.quarters.split('|') : []
            let districts = this.districts ? this.districts.split('|') : []
            let district_current = ''
            let quarter_count = 0
            let quarter_list = []

            this.districts_data.forEach(district_row => {
                if (district == district_row.id) {
                    district_current = district_row
                    district_current.quarters.forEach(quarter_row => {
                        quarter_list.push(quarter_row.id)
                        if (quarters.includes(String(quarter_row.id))) {
                            quarter_count++
                        }
                    })
                }
            })

            if (event.target.checked == true) {
                if (district_current.quarters.length != quarter_count + 1) {
                    quarters.push(quarter)
                } else {
                    district_current.quarters.forEach(quarter_row => {
                        quarters.remove(String(quarter_row.id))
                    })
                }
            } else {
                if (quarter_count) {
                    quarters.remove(quarter)
                    if (!quarters.length) {
                        districts.remove(String(district))
                    }
                } else {
                    console.log(district_current)
                    district_current.quarters.forEach(quarter_row => {
                        if (quarter_row.id != quarter) {
                            quarters.push(String(quarter_row.id))
                        }
                    })
                    if (district_current.quarters.length == 1) {
                        districts.remove(String(district))
                    }
                }
            }

            window.events.$emit('list.unlock.polygons')

            let data = {
                id: districts.join('|'),
                city_id: this.city,
                quarters_id: quarters.join('|'),
            }

            window.events.$emit('search_by_districts', data)
        }
    },
}
</script>